export default class MultiPageRegisterForm {
  #ui;
  #currentTab;

  get eventTarget() {
    return this.#ui.form;
  }

  get form() {
    return this.#ui.form;
  }

  constructor() {
    this.#currentTab = 0;
  }

  init() {
    this.#cacheUiElements();
    this.#bindEvents();

    this.#showFirstOrInvalidTab();
  }

  #cacheUiElements() {
    this.#ui = {
      form: $("form"),
      tabs: $("form").find(".tab"),
      previousButton: $("input#previous"),
      nextButton: $("input#next"),
      registerButton: $("input#register"),
    };
  }

  #bindEvents() {
    this.#ui.previousButton.on("click", (e) => {
      e.preventDefault();
      this.#showNextPrev(-1);
    });
    this.#ui.nextButton.on("click", (e) => {
      e.preventDefault();
      this.#ui.form.validate();
      if (this.#ui.form.valid()) {
        this.#showNextPrev(1);
      }
    });
  }

  /**
   * Show the first tab that contains a field that is invalid.
   */
  #showFirstOrInvalidTab() {
    let isErrors = false;

    this.#currentTab = this.#ui.tabs.length - 1;
    this.#ui.tabs.find(".validation-field.field-validation-error").each((index, element) => {
      isErrors = true;
      const $tab = $(element).parents(".tab");
      if ($tab.index() < this.#currentTab) {
        this.#currentTab = $tab.index();
      }
    });

    // Go to the first page if there were no errors
    if (!isErrors) {
      this.#currentTab = 0;
    }

    this.#showTab(this.#currentTab);
  }

  /**
   * Show the specified tab of the form.
   * @param {int} index the index of the tab to display
   */
  #showTab(index) {
    this.#ui.tabs.eq(index).removeClass("hidden");

    if (index === 0) {
      this.#ui.previousButton.addClass("hidden");
    } else {
      this.#ui.previousButton.removeClass("hidden");
    }

    if (index === (this.#ui.tabs.length - 1)) {
      this.#ui.nextButton.addClass("hidden");
      this.#ui.registerButton.removeClass("hidden").attr("disabled", false);
    } else {
      this.#ui.nextButton.removeClass("hidden");
      this.#ui.registerButton.addClass("hidden").attr("disabled", true);
    }

    // Focus the first focusable element:
    this.#ui.tabs.eq(index).find("button, a, input, select, textarea, [tabindex]:not([tabindex='-1'])").eq(0).focus();
  }

  /**
   * Show the next or previous tab in the form.
   * @param {int} n pass 1 to show the next tab or -1 for the previous tab
   */
  #showNextPrev(n) {
    this.#ui.tabs.eq(this.#currentTab).addClass("hidden");

    this.#currentTab += n;
    if (this.#currentTab >= this.#ui.tabs.length) {
      this.#currentTab = this.#ui.tabs.length;
      return;
    }

    this.#showTab(this.#currentTab);
    this.eventTarget.trigger("next-prev.register-form");
  }
}
